import { useFadeIn } from '../../../hooks/useFadeIn';

export default function Challenges() {
  const { ref, isVisible } = useFadeIn({ threshold: 0.1 });

  const challenges = [
    {
      title: 'メンタルヘルス不調による\n突然の休職・離職',
      description: '予期せぬ欠員により、業務の停滞や他の従業員への負担増加が発生します',
      image: '/assets/senteo-corp/img/service/problem_1.jpg',
      dark: false
    },
    {
      title: '社内リソース不足で\n十分なケアができない',
      description: '人事担当者の業務過多により、従業員一人ひとりに適切な対応ができていません',
      image: '/assets/senteo-corp/img/service/problem_2.jpg',
      dark: false
    },
    {
      title: '復職支援の適切な\n進め方がわからない',
      description: '休職者の復帰タイミングや段階的な業務復帰の方法に不安を感じています',
      image: '/assets/senteo-corp/img/service/problem_3.jpg',
      dark: false
    },
    {
      title: '採用・育成コストの増大',
      description: '離職による補充採用や新人教育に多大な時間とコストがかかっています',
      image: '/assets/senteo-corp/img/service/problem_4.jpg',
      dark: false
    }
  ];

  return (
    <section className="min-h-screen py-24 bg-[#FDFBF7] flex items-center">
      <div 
        ref={ref}
        className={`max-w-7xl mx-auto px-6 w-full transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}
      >
        <div className="mb-16">
          <h2 className="text-4xl lg:text-5xl font-light text-[#2C2C2C] leading-relaxed">
            こんなお悩みは<br />ありませんか?
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          {challenges.map((challenge, index) => (
            <div 
              key={index}
              className="relative rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 group cursor-pointer bg-white"
              style={{ 
                minHeight: '320px',
                transitionDelay: `${index * 100}ms`
              }}
            >
              <div className="absolute inset-0">
                <img 
                  src={challenge.image} 
                  alt={challenge.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
              </div>
              <div className="relative p-8 h-full flex flex-col justify-end">
                <div>
                  <h3 className="text-2xl font-bold text-white mb-3 whitespace-pre-line leading-tight">
                    {challenge.title}
                  </h3>
                  <p className="text-white/90 text-sm leading-relaxed">
                    {challenge.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
